import { Box, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { RoomsPromo } from './rooms-promo';
import { RoomsResultsOverview } from './rooms-results-overview';
import { RoomsResultsSkeleton } from './rooms-results-skeleton';
import { styles } from './styles';
import { RoomsResultsProps } from './types';

const ResultsMessage: FC<{ children: ReactNode }> = ({ children }) => (
    <Box css={styles.resultsSection}>
        <Typography>{children}</Typography>
    </Box>
);

export const RoomsResults: FC<RoomsResultsProps> = ({
    error,
    isLoading,
    isSearchPending,
    isError,
    results,
    hasSelectedDates,
    hasSearched,
}) => {
    const { t } = useTranslation();

    if (error) {
        return <ResultsMessage>{error}</ResultsMessage>;
    }

    if (!hasSelectedDates) {
        return <RoomsPromo />;
    }

    // Results still on screen are for the previous search, so swap them out as soon as the selection changes
    if (isSearchPending) {
        return <RoomsResultsSkeleton />;
    }

    if (results?.length) {
        return <RoomsResultsOverview results={results} />;
    }

    if (isLoading) {
        return <RoomsResultsSkeleton />;
    }

    if (isError) {
        return <ResultsMessage>{t('rooms_page_results_error')}</ResultsMessage>;
    }

    if (hasSearched && results) {
        return <ResultsMessage>{t('rooms_page_no_results')}</ResultsMessage>;
    }

    return null;
};
